var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgLessonGray = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7001 8.9L13.4001 9.2C12.6001 9.2 11.9001 8.7 11.9001 7.9L11.6001 5.5H11.7001L15.7001 8.9Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6002 17.6996C16.7002 18.4996 16.1002 19.1996 15.4002 19.1996L7.9002 19.9996H7.8002H7.6002C6.8002 20.0996 6.1002 19.4996 6.1002 18.7996L5.0002 7.59961C4.9002 6.79961 5.5002 6.09961 6.2002 6.09961L11.5002 5.59961H11.6002L11.8002 7.89961C11.8002 8.09961 11.9002 8.29961 12.0002 8.39961C12.1002 8.49961 12.2002 8.69961 12.3002 8.79961C12.6002 9.09961 13.0002 9.19961 13.4002 9.19961H13.6002H13.7002L15.7002 8.99961L16.6002 17.6996Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2998 8.89961L15.8998 8.99961H15.7998L13.9998 9.19961C13.8998 9.19961 13.7998 9.19961 13.7998 9.19961C13.0998 9.19961 12.5998 8.59961 12.4998 7.99961L12.2998 6.09961V5.99961V5.59961H12.3998L16.2998 8.89961Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 17.6996C16.6998 18.4996 16.0998 19.1996 15.3998 19.1996L7.89981 19.9996C7.29981 19.8996 6.69981 19.3996 6.69981 18.7996L5.59981 7.59961C5.49981 6.79961 6.09981 6.09961 6.79981 6.09961L11.5998 5.59961H11.6998H11.9998H12.0998V5.99961V6.09961L12.2998 7.89961C12.3998 8.59961 12.8998 9.09961 13.5998 9.09961C13.6998 9.09961 13.7998 9.09961 13.7998 9.09961L15.7998 8.99961L16.5998 17.6996Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 8.3H16.2997C15.3997 8.3 14.6997 7.6 14.6997 6.7V4L14.7997 4.1L18.9997 8.3Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 8.3V18.4C18.9999 19.3 18.2999 20 17.3999 20H8.4999C7.5999 20 6.8999 19.3 6.8999 18.4V5.6C6.8999 4.7 7.5999 4 8.4999 4H14.5999H14.6999V6.7C14.6999 7.6 15.3999 8.3 16.2999 8.3H18.9999Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 8.3V18.4C19.0002 19.3 18.3002 20 17.4002 20H9.3002C8.4002 20 7.7002 19.3 7.7002 18.4V5.6C7.7002 4.7 8.4002 4 9.3002 4H14.6002H14.7002V6.7C14.7002 7.6 15.4002 8.3 16.3002 8.3H19.0002Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 11H10.5C10.2 11 10 10.8 10 10.5C10 10.2 10.2 10 10.5 10H16.4C16.7 10 16.9 10.2 16.9 10.5C16.9 10.8 16.6 11 16.4 11Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 14H10.5C10.2 14 10 13.8 10 13.5C10 13.2 10.2 13 10.5 13H16.4C16.7 13 16.9 13.2 16.9 13.5C16.9 13.8 16.6 14 16.4 14Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 16.5996H10.5C10.2 16.5996 10 16.3996 10 16.0996C10 15.7996 10.2 15.5996 10.5 15.5996H13.8C14.1 15.5996 14.3 15.7996 14.3 16.0996C14.3 16.3996 14.1 16.5996 13.8 16.5996Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLessonGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LessonGray.6a7d38f3.svg";
export { ForwardRef as ReactComponent };